import * as dateFns from 'date-fns'

// Constants
import * as constants from 'Constants'

const formatValue =
  (key) =>
  ({ id, type }) => {
    return key === 'merchants' ? { id, type } : id
  }

const timeUnitsMap = { days: 1, weeks: 2, months: 3 }
export const getFormattedFilters = (filters) => {
  return Object.entries(filters).reduce((acc, [key, value]) => {
    const isArray = Array.isArray(value)
    if (key === 'columns') {
      return { ...acc, [key]: value }
    }
    if (
      key === 'createdDate' ||
      key === 'dates' ||
      key === 'dateTime' ||
      key === 'dueDate' ||
      key === 'transactionDate'
    ) {
      return {
        ...acc,
        [key]: {
          min:
            value?.min !== '' && value?.min !== undefined
              ? dateFns.toDate(dateFns.parseISO(value?.min).setUTCHours(0, 0, 0, 0)).toISOString()
              : null,
          max:
            value?.max !== '' && value?.max !== undefined
              ? dateFns
                  .toDate(dateFns.parseISO(value?.max).setUTCHours(23, 59, 59, 999))
                  .toISOString()
              : null,
        },
      }
    }
    // Non multi select fields
    if (key === 'paymentStatuses' || key === 'riskScores') {
      if (isArray) {
        return value[0] ? { ...acc, [key]: [value[0]?.id] } : acc
      }
      return value ? { ...acc, [key]: [value.id] } : acc
    }
    if (key === 'timeUnits') {
      return { ...acc, [key]: timeUnitsMap[value] }
    }
    if ((!value && value !== false) || (isArray && !value.length)) {
      return acc
    }
    return { ...acc, [key]: isArray ? value.map(formatValue(key)) : value }
  }, {})
}

export const getStrippedFilters = (params) => {
  const strippedFilters = Object.keys(params).filter((key) => {
    return [...constants.expenseFilterFields].includes(key)
  })
  return strippedFilters.reduce((acc, key) => {
    return {
      ...acc,
      [key]: params[key],
    }
  }, {})
}

export const stripEmptyFilters = (filters) => {
  return Object.entries(filters).reduce((acc, [key, value]) => {
    const isArray = Array.isArray(value)
    if (!value || (isArray && !value.length)) {
      return acc
    }
    return { ...acc, [key]: value }
  }, {})
}

export const getSelectedDateRangeString = (dates) => {
  if (!dates) {
    return ''
  }
  const { min, max } = dates
  const today = new Date()
  if (
    dateFns.isSameDay(dateFns.toDate(Date.parse(min)), dateFns.startOfMonth(today)) &&
    dateFns.isSameDay(dateFns.toDate(Date.parse(max)), today)
  ) {
    return 'Month-to-Date'
  }
  if (
    dateFns.isSameDay(dateFns.toDate(Date.parse(min)), dateFns.startOfWeek(today)) &&
    dateFns.isSameDay(dateFns.toDate(Date.parse(max)), today)
  ) {
    return 'Week-to-Date'
  }
  if (
    dateFns.isSameDay(dateFns.toDate(Date.parse(min)), dateFns.sub(today, { days: 7 })) &&
    dateFns.isSameDay(dateFns.toDate(Date.parse(max)), today)
  ) {
    return 'Last 7 Days'
  }
  if (
    dateFns.isSameDay(dateFns.toDate(Date.parse(min)), dateFns.sub(today, { days: 30 })) &&
    dateFns.isSameDay(dateFns.toDate(Date.parse(max)), today)
  ) {
    return 'Last 30 Days'
  }
  if (
    dateFns.isSameDay(dateFns.toDate(Date.parse(min)), dateFns.sub(today, { days: 60 })) &&
    dateFns.isSameDay(dateFns.toDate(Date.parse(max)), today)
  ) {
    return 'Last 60 Days'
  }
  if (
    dateFns.isSameDay(dateFns.toDate(Date.parse(min)), dateFns.sub(today, { days: 90 })) &&
    dateFns.isSameDay(dateFns.toDate(Date.parse(max)), today)
  ) {
    return 'Last 90 Days'
  }
  return `${new Date(Date.parse(min)).toLocaleDateString()} - ${new Date(
    Date.parse(max),
  ).toLocaleDateString()}`
}
